module.exports = __webpack_public_path__ + "static/media/check_red.8e7f1520.svg";